// SamostoyatelnayaRegistratsiyaTantsoraFederatsii
import React, { useState, useEffect } from 'react';
import 'moment/locale/ru';
import { errorCatch, QueryDetail, QueryOrder, QueryParam, READWITH, useAuth } from 'fennec-ui';

import Icofont from 'react-icofont';
import { List, Image, InfiniteScroll, Form, ConfigProvider, SearchBar, Button } from 'antd-mobile'
import {
    List as VirtualizedList,
    AutoSizer,
    WindowScroller,
} from 'react-virtualized'
import enUS from 'antd-mobile/es/locales/en-US'
var _ = require('lodash');

function ShkolaListSelector(props) {
    const { value, onChange } = props;
    const auth = useAuth();
    // const ContainerHeight = 400;
    // const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState();
    const [data, setData] = useState([]);
    const [page, setPage] = useState();
    const appendData = (page) => {
        return new Promise((resolve, reject) => {
            READWITH(auth, "ShkoliFederatsii", [
                QueryDetail("model"),
                QueryOrder("nazvanieShkoliTantsev", "ASC"),
                QueryParam("w-nnu-DokumentRegistratsii", 0),
                QueryParam("w-nu-DokumentVikhodaIzFederatsii", 0),
                (page.quick && page.quick.length <= 6) ? QueryParam("w-co-nazvanieShkoliTantsev", page.quick) : undefined,
                (page.quick && page.quick.length > 6) ? QueryParam("w-sim-nazvanieShkoliTantsev", page.quick) : undefined,
                QueryParam("page", page.current),
                // QueryParam("count", 2),
            ], ({ data }) => {
                resolve(data)
            }, (err) => errorCatch(err, () => reject(err)));
        });
    };
    useEffect(() => {
        if (selected) {
            onChange(selected);
        }
    }, [selected])
    useEffect(() => {
        if (value) {
            setSelected(value);
        }
    }, [value])
    useEffect(() => {
        async function fetchData() {
            let data = await appendData({ current: 1, quick: "", total: undefined });
            // console.log("useEffect",data.number+"/"+data.totalPages, data);
            setData(data?.content);
            setPage({ current: 1, quick: "", total: data.totalPages });
        }
        fetchData();
    }, []);

    function rowRenderer({
        index,
        key,
        style,
    }) {
        const item = data[index]
        if (!item) return

        return (
            <List.Item
                onClick={() => setSelected(item.ID)}
                key={key}
                arrow={false}
                style={{ ...style, padding: "0px 10px", borderRadius: "4px", backgroundColor: (selected === item.ID) ? "#d7f4ff" : "transparent" }}
                description={item.regionalnoeOtdelenie.nazvanie}
            >
                {item.nazvanieShkoliTantsev}
            </List.Item>
        )
    }

    const _onSearch = async (v) => {
        let data = await appendData({ current: 1, quick: v, total: undefined });
        setData(data?.content);
        setPage({ current: 1, quick: "", total: data.totalPages });
    };
    const onSearch = React.useCallback(_.throttle(_onSearch, 3000, { trailing: true }), []);

    const onScroll = React.useCallback(async (e) => {
        if (!page || page.current > page.total) return;
        let data = await appendData({ ...page, current: page.current + 1 });
        // console.log("onScroll", data.number+"/"+data.totalPages, data);
        setData(o => [...o, ...data.content]);
        setPage(o => ({ current: page.current + 1, quick: page.quick, total: data.totalPages }));
    }, [page]);
    return (<div>
        <div>
            <ConfigProvider locale={{
                ...enUS,
                common: {
                    loading: "Загрузка"
                },
                InfiniteScroll: {
                    noMore: "Конец списка",
                    failedToLoad: "Ошибка загрузки",
                    retry: "Обновить"
                },
                SearchBar:{
                    name: "Поиск",
                }
            }}>
                <div style={{
                    padding: "12px",
                    background: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    position: "sticky",
                    zIndex: "999999",
                    top: "0",
                    left: "0",
                }}>
                    <div style={{ flex: "auto" }}>
                        <SearchBar onSearch={_onSearch} onChange={onSearch} />
                    </div>
                    {/* <div style={{ flex: "none", paddingLeft: "12px" }}>
                        <Button size='small' color='primary' onClick={_onSearch}>
                            <Icofont icon="search" />
                        </Button>
                    </div> */}
                </div>
                <WindowScroller
                    onScroll={({ scrollTop }) => {
                        // console.log('scrollTop', scrollTop)
                    }}
                >
                    {({ height, scrollTop, isScrolling }) => (
                        <List>
                            <AutoSizer disableHeight>
                                {({ width }) => (
                                    <VirtualizedList
                                        autoHeight
                                        rowCount={data.length}
                                        rowRenderer={rowRenderer}
                                        width={width}
                                        height={height}
                                        rowHeight={70}
                                        overscanRowCount={10}
                                        isScrolling={isScrolling}
                                        scrollTop={scrollTop}
                                    />
                                )}
                            </AutoSizer>
                        </List>
                    )}
                </WindowScroller>
                <InfiniteScroll loadMore={onScroll} hasMore={page && page.current < page.total} />
            </ConfigProvider>
        </div>
        {/* <div style={{ paddingBottom: "25px" }}>
            <Search
                enterButton={<Icofont icon="search" />}
                onSearch={_onSearch}
                onChange={(e) => onSearch(e.target.value)}
            />
        </div>
        <List loading={loading}>
            <VirtualList
                data={data}
                height={ContainerHeight}
                itemHeight={47}
                itemKey="ID"
                onScroll={onScroll}
            >
                {(item) => (
                    <List.Item key={item.ID} style={{ cursor: "pointer", padding: "12px 10px", borderRadius: "4px", backgroundColor: (selected === item.ID) ? "#d7f4ff" : "transparent" }} onClick={() => setSelected(item.ID)}>
                        <List.Item.Meta
                            title={<a href="#">{item.nazvanieShkoliTantsev}</a>}
                            description={item.regionalnoeOtdelenie.nazvanie}
                        />
                    </List.Item>
                )}
            </VirtualList>
        </List> */}
    </div>)
}

export default function RegistratsiyaTantsoraShkoli(props) {
    const { auth } = props;

    return (
        <div>
            <Form
                form={props.form}
                onFinish={props.submit}
                // layout={"vertical"}
                initialValues={{
                }}
            >
                <Form.Item
                    name={"shkolaID"}
                    // label={"Школы федерации"}
                    rules={[{ required: true, message: 'Выберите школу!' }]}
                >
                    <ShkolaListSelector />
                </Form.Item>

            </Form>
        </div>
    );
}
